module.exports = __webpack_public_path__ + "static/media/F-2-mobile.533f0378.webp";